import Color from "color";

import { colors } from "@apps/viewer/src/ts/config";

/**
 * Collection of shared configurations within the header.
 */
export const config = {
    /**
     * Generate the background color to apply to the dropdowns when expanded.
     */
    backgroundColor: Color(colors.white)
        .alpha(0.97)
        .toString(),

    /**
     * Generate the color of the dropshadow that's applied to the dropdowns when
     * they're expanded.
     */
    dropShadowColor: Color(colors.black)
        .alpha(0.25)
        .toString(),

    /**
     * Specifies the margin that'll be added between the element which we're
     * going to point the dropdown towards, and the dropdown itself.
     */
    referenceMargin: 15,

    /**
     * Specifies the minimum margin between the dropdown itself and the outer
     * horizontal edges of the viewport.
     */
    viewportHorizontalMargin: 15,

    /**
     * Specifies the minimum margin between the dropdown itself and the outer
     * vertical edges of the viewport.
     */
    viewportVerticalMargin: 15,
};
